<template>
    <div>
        <loading v-if="fetchingGroupsAndFilters" class="mb-32"></loading>

        <div v-else-if="filterGroups.length > 0">
            <h2 class="text-body font-semibold first-letter:uppercase mb-8">
                {{ $t('jobs.create.headers.tags') }}
            </h2>

            <p class="w-1/2 text-black mb-16">
                {{ $t('jobs.filters.description') }}
            </p>

            <div class="grid grid-cols-3 gap-8">
                <div
                    v-for="group in filterGroups"
                    :key="'group-' + group.id"
                >
                    <select-dropdown
                        :value="selectedFilters[group.id]"
                        @change="setSelectedFilters($event, group.id)"
                        @input="setSelectedFilters($event, group.id)"
                        multiple
                        searchable
                        :autoTranslate="false"
                        :limited-items-count="5"
                        :truncate="true"
                        :loading="fetchingGroupsAndFilters"
                        :options="filters(group)"
                        :placeholder="$t('form.dropdown.placeholder').toString()"
                        remove-icon
                        can-select-all
                        :input-label="group.title[locale] ?? $t('general.missing_translation')"
                    />
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import * as jobs from '../../services/JobService';
import Loading from './Loading.vue';
import FilterGroup from "../../models/FilterGroup";
import {normalizeJson} from "../../../shared/helpers";
import SelectDropdown from "../forms/SelectDropdown.vue";
import LabelWithMissingTranslation from "../LabelWithMissingTranslation.vue";
import {mapStores} from "pinia";
import {useMainStore} from "../../state/store";
import {useRepo} from "pinia-orm";

export default {
    name: "JobFilterGroups",
    components: {SelectDropdown, Loading, LabelWithMissingTranslation},
    props: {
        job: Object,
        value: Object,
    },
    data() {
        return {
            fetchingGroupsAndFilters: false,
        };
    },
    computed: {
        ...mapStores(useMainStore),
        locale() {
            return this.mainStore.locale;
        },
        currentCompany() {
            return this.mainStore.currentCompany;
        },
        selectedFilters: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        filterGroups() {
            return useRepo(FilterGroup)
                .orderBy('order')
                .with('filters', (query) => {
                    query.orderBy('order');
                })
                .get();
        },
    },
    methods: {
        fetchGroupsAndFilters() {
            this.fetchingGroupsAndFilters = true
            // fetch all groups with all filters
            jobs.filterGroups(true).then(async result => {
                await useRepo(FilterGroup).save(normalizeJson(result.data))
            }).finally(() => {
                this.formatSelectedFilters(this.job ? this.job.filters : [])

                this.fetchingGroupsAndFilters = false;
            })
        },
        filters(group) {
            return group['filters'].filter(filter => {
                if (Number.isInteger(group.id)) {
                    // Make sure that a filter can only be put in a group once
                    for (let key in this.selectedFilters) {
                        if (group.id !== parseInt(key) && this.selectedFilters[key].includes(filter.id)) {
                            return false
                        }
                    }
                }
                return true
            }).map(filter => ({
                value: filter.id,
                label: filter.title[this.locale]
            }))
        },
        /**
         * Reformats the selected filters to be grouped per filter group.
         */
        formatSelectedFilters(selectedFilters) {
            let groups = this.filterGroups
            //let ungroupedFilterGroupId = groups.find(group => !Number.isInteger(group.id)).id

            for (let group of groups) {
                const groupId = group.id; // || ungroupedFilterGroupId
                this.selectedFilters[groupId] = []
            }

            for (let filter of selectedFilters) {
                const groupId = filter.pivot.filter_group_id; // || ungroupedFilterGroupId
                this.selectedFilters[groupId].push(filter.id)
            }
        },
        /**
         * Sets the selected filters upon change
         */
        setSelectedFilters(filterIds, groupId) {
            this.selectedFilters[groupId] = filterIds

            // Use spread operator to redefine object root so component gets re-rendered
            this.selectedFilters = {...this.selectedFilters}
        },
    },
    mounted() {
        this.fetchGroupsAndFilters()
    },
}
</script>
